import {Pipe, PipeTransform} from '@angular/core';
import {countryConfig} from 'src/country-config/country-config';

@Pipe({
  name: 'multiCountryCurrency',
})
export class MultiCountryCurrencyPipe implements PipeTransform {
  private currencySymbol: string;
  constructor() {
    this.currencySymbol = countryConfig.currencySymbol;
  }

  transform(price: any, custom = false): string {
      let decimals = 0;
      if (countryConfig.bolivarDigital){
        decimals = 2;
      }
      if (countryConfig.bolivarDigital && custom) {
        decimals = 0;
        price = price * 1000000;
        this.currencySymbol = 'Bs.S ';
      }

      price = price ? price.toString() : '0';
      price = parseFloat(price.replace(/[^0-9\.]/g, ''));

      if (Number.isNaN(price) || price === 0) {
          return parseFloat('0').toFixed(decimals);
      }

      price = price.toFixed(decimals);
      const amountParts = price.split('.');
      amountParts[0] = new Intl.NumberFormat('es-CO').format(amountParts[0]);


      return `${this.currencySymbol}${amountParts.join('.')}`;
  }
}
